<!--董事会-->
<template>
  <div>
      <!--董事会内容布局-->
      <div v-for="(director, index) in $t('investor.court.directors')" :key="index" 
           :class="index % 2 === 0 ? 'dsh_layout_1' : 'dsh_layout_2'">
        <div class="dsh_width_center">
          <div v-if="index === 0" class="dsh_title_h2">{{ $t('investor.court.title') }}</div>
          <div class="dsh_list_box">
            <div :class="index % 2 === 0 ? 'dsh_img fr' : 'dsh_img fl'">
              <img class="img_1" :src="getDirectorImage(index)">
              <img :class="index % 2 === 0 ? 'img_2' : 'img_3'" :src="getDirectorImage(index)">
            </div>
            <div :class="index % 2 === 0 ? 'dsh_word_box fl' : 'dsh_word_box fr'">
              <div class="name">{{ director.name }}</div>
              <div class="zhiwei">{{ director.title }}</div>
              <div class="introduce">{{ director.intro }}</div>
              <Collapse>
                <div class="introduce" v-show="showDetails[index]">
                  <span v-html="formatDetail(director.detail)"></span>
                </div>
              </Collapse>
              <i :class="showDetails[index] ? 'iconfont icon-website-xiangshang' : 'iconfont icon-website-xiangxiajiantou'" 
                 @click="toggleDetail(index)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Collapse from '../../utils/expansion.js'

export default {
    name: 'investorCourt',
    components: { Collapse },
    props: {},
    created(){
        
    },
    data () {
      return {
        showDetails: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed:{
      
    },
    methods:{
      toggleDetail(index) {
        this.$set(this.showDetails, index, !this.showDetails[index])
      },
      getDirectorImage(index) {
        const images = [
          require('../../../../assets/img/investor/leijun.jpg'),
          require('../../../../assets/img/investor/zoutao.jpg'),
          require('../../../../assets/img/investor/qiubojun.jpg')
        ]
        return images[index] || images[0]
      },
      formatDetail(text) {
        return text.replace(/\n/g, '<br>')
      }
    }
}
</script>
